import { render, staticRenderFns } from "./search-cover.vue?vue&type=template&id=488624c0"
import script from "./search-cover.vue?vue&type=script&lang=js"
export * from "./search-cover.vue?vue&type=script&lang=js"
import style0 from "./search-cover.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports